export default function ComparazioneMetodi() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#F0FDF4] via-white to-[#FAF5FF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-6">
            Comparazione con i Metodi Tradizionali
          </h2>
          <p className="text-xl text-[#1C1C1C]/70 max-w-4xl mx-auto leading-relaxed">
            Analisi tecnica delle differenze sostanziali tra il BCI e le metodologie 
            attualmente utilizzate nel mercato della valutazione aziendale.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-white rounded-xl shadow-lg overflow-hidden">
            <thead>
              <tr className="bg-gradient-to-r from-[#E879F9] to-[#E879F9]/80">
                <th className="px-6 py-5 text-left text-base font-semibold text-white border-r border-white/20">
                  Parametro di Valutazione
                </th>
                <th className="px-6 py-5 text-left text-base font-semibold text-white border-r border-white/20">
                  Metodi Tradizionali
                </th>
                <th className="px-6 py-5 text-left text-base font-semibold text-white">
                  Brand Capital Index
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-100 hover:bg-[#F0FDF4]/30 transition-colors">
                <td className="px-6 py-5 text-sm font-medium text-[#0B1F3B] border-r border-gray-100">
                  Numero di Variabili Considerate
                </td>
                <td className="px-6 py-5 text-sm text-[#1C1C1C]/70 border-r border-gray-100">
                  5-12 variabili
                </td>
                <td className="px-6 py-5 text-sm font-semibold text-[#22C55E]">
                  47 variabili integrate
                </td>
              </tr>

              <tr className="border-b border-gray-100 hover:bg-[#FAF5FF]/30 transition-colors">
                <td className="px-6 py-5 text-sm font-medium text-[#0B1F3B] border-r border-gray-100">
                  Approccio Metodologico
                </td>
                <td className="px-6 py-5 text-sm text-[#1C1C1C]/70 border-r border-gray-100">
                  Lineare e settoriale
                </td>
                <td className="px-6 py-5 text-sm font-semibold text-[#22C55E]">
                  Multidimensionale e sistemico
                </td>
              </tr>

              <tr className="border-b border-gray-100 hover:bg-[#F0FDF4]/30 transition-colors">
                <td className="px-6 py-5 text-sm font-medium text-[#0B1F3B] border-r border-gray-100">
                  Validazione Scientifica
                </td>
                <td className="px-6 py-5 text-sm text-[#1C1C1C]/70 border-r border-gray-100">
                  Prassi consolidata
                </td>
                <td className="px-6 py-5 text-sm font-semibold text-[#22C55E]">
                  Certificazione ISO 10668
                </td>
              </tr>

              <tr className="border-b border-gray-100 hover:bg-[#FAF5FF]/30 transition-colors">
                <td className="px-6 py-5 text-sm font-medium text-[#0B1F3B] border-r border-gray-100">
                  Tempo di Elaborazione
                </td>
                <td className="px-6 py-5 text-sm text-[#1C1C1C]/70 border-r border-gray-100">
                  3-6 mesi
                </td>
                <td className="px-6 py-5 text-sm font-semibold text-[#22C55E]">
                  4-8 settimane
                </td>
              </tr>

              <tr className="border-b border-gray-100 hover:bg-[#F0FDF4]/30 transition-colors">
                <td className="px-6 py-5 text-sm font-medium text-[#0B1F3B] border-r border-gray-100">
                  Costo Medio
                </td>
                <td className="px-6 py-5 text-sm text-[#1C1C1C]/70 border-r border-gray-100">
                  €15.000 - €50.000
                </td>
                <td className="px-6 py-5 text-sm font-semibold text-[#22C55E]">
                  €8.000 - €25.000
                </td>
              </tr>

              <tr className="border-b border-gray-100 hover:bg-[#FAF5FF]/30 transition-colors">
                <td className="px-6 py-5 text-sm font-medium text-[#0B1F3B] border-r border-gray-100">
                  Riconoscimento Internazionale
                </td>
                <td className="px-6 py-5 text-sm text-[#1C1C1C]/70 border-r border-gray-100">
                  Variabile per metodo
                </td>
                <td className="px-6 py-5 text-sm font-semibold text-[#22C55E]">
                  Standard ISO certificato
                </td>
              </tr>

              <tr className="hover:bg-[#F0FDF4]/30 transition-colors">
                <td className="px-6 py-5 text-sm font-medium text-[#0B1F3B] border-r border-gray-100">
                  Aggiornamento Valutazione
                </td>
                <td className="px-6 py-5 text-sm text-[#1C1C1C]/70 border-r border-gray-100">
                  Annuale o biennale
                </td>
                <td className="px-6 py-5 text-sm font-semibold text-[#22C55E]">
                  Monitoraggio continuo disponibile
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-[#E879F9]/10 to-[#E879F9]/5 p-8 rounded-xl border-2 border-[#E879F9]/20">
            <div className="w-14 h-14 flex items-center justify-center bg-[#E879F9] rounded-lg mb-6">
              <i className="ri-line-chart-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#0B1F3B] mb-4">
              Precisione Superiore
            </h3>
            <p className="text-base text-[#1C1C1C]/70 leading-relaxed">
              Il BCI integra 47 variabili contro le 5-12 dei metodi tradizionali, 
              garantendo una valutazione più accurata e completa del valore del brand.
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#22C55E]/10 to-[#22C55E]/5 p-8 rounded-xl border-2 border-[#22C55E]/20">
            <div className="w-14 h-14 flex items-center justify-center bg-[#22C55E] rounded-lg mb-6">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#0B1F3B] mb-4">
              Certificazione Internazionale
            </h3>
            <p className="text-base text-[#1C1C1C]/70 leading-relaxed">
              Unico metodo certificato ISO 10668 in Italia, riconosciuto a livello 
              internazionale per la valutazione monetaria del brand.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
